




import Vue from "vue";

export default Vue.extend({
    props: {
        datasets: Array,
        labels: Array,
    },
    computed: {
        headers() {
            return [{ text: "Name", value: "Name" }, ...this.datasets.map((c) => ({ text: c.label, value: c.label }))];
        },
        items: function() {
            var res = [];
            this.labels.forEach((l, index) => {
                var item = { Name: l };
                this.datasets.forEach((d) => {
                    item[d.label] = d.data[index];
                });
                res.push(item);
            });
            return res;
        },
    },
});
